//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import config from '@/config';
const getTime = () => {
  const nowDate = new Date();
  const year = nowDate.getFullYear();
  const month = nowDate.getMonth() + 1 < 10 ? `0${nowDate.getMonth() + 1}` : nowDate.getMonth() + 1;
  const day = nowDate.getDate() < 10 ? `0${nowDate.getDate()}` : nowDate.getDate();
  return `${year}${month}${day}`;
};
export default {
  props: {
    app: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      env: config.env,
      date: getTime(),
      version: '',
    };
  },
  computed: {
    ...mapGetters('user', ['getUserInfo', 'getTenantInfo']),
    operator() {
      return this.getUserInfo.staffname;
    },
    tenement() {
      return `T${this.getTenantInfo.id}`;
    },
    str() {
      const { env, tenement, app, date, operator, version } = this;
      if (!version) {
        return '';
      }
      const str = `${env}-${tenement}${app ? `-${app}` : ''}-${date}-${operator}-${version}`;
      return str;
    },
  },
  methods: {
    changeVersion() {
      this.$emit('change', this.str);
    },
  },
};
